import { useRef, useCallback } from 'react'

export function useAddressHook() {
	const addressByCoordinateMap = useRef(new Map())

	const toCoordinateKey = ({ latitude, longitude }) => {
		return `${latitude}_${longitude}`
	}

	const hasCoordinate = useCallback(
		(key) => {
			return addressByCoordinateMap.current.has(key)
		},
		[addressByCoordinateMap]
	)

	const getCachedAddress = useCallback(
		(key) => {
			return addressByCoordinateMap.current.get(key) || ''
		},
		[addressByCoordinateMap]
	)

	const fetchAddress = useCallback(
		({ latitude, longitude }) => {
			return new Promise((resolve, reject) => {
				const key = toCoordinateKey({ latitude, longitude })
				if (hasCoordinate(key)) {
					resolve(getCachedAddress(key))
					return
				}

				const location = new window.google.maps.LatLng(latitude, longitude)
				const geocoder = new window.google.maps.Geocoder()

				geocoder.geocode({ location }, (res, status) => {
					if (status === 'OK' && res?.length) {
						const address = res[0].formatted_address
						addressByCoordinateMap.current.set(key, address) // cache it
						resolve(address)
					} else {
						reject('')
					}
				})
			})
		},
		[addressByCoordinateMap]
	)

	return {
		toCoordinateKey,
		hasCoordinate,
		getCachedAddress,
		fetchAddress,
	}
}
